import {
    moneyP
} from './money'

export default moneyP;


// WEBPACK FOOTER //
// ./src/filter/index.js